export function explodeString(input) {
  if (input.length < 20) return input;

  const splitChars = /(\s|-)/;
  const parts = input.split(splitChars);

  let firstLine = "";
  let secondLine = "";
  let switchToSecond = false;

  for (let i = 0; i < parts.length; i++) {
    const part = parts[i];

    if (!switchToSecond && (firstLine + part).length <= 20) {
      firstLine += part;
    } else if (part.length > 20 && i === 0) {
      const firstPart = part.substring(0, 14);
      const secondPart = part.substring(14);

      firstLine = firstPart;
      secondLine = secondPart;
    } else {
      switchToSecond = true;
      secondLine += part;
    }
  }

  return secondLine ? `${firstLine}<br/>${secondLine}` : firstLine;
}
